export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5234.12a0c9f5.jpg";